// @ngInject
export function focusMe($parse: ng.IParseService): ng.IDirective {
  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any) {
      let model = $parse(attrs.focusMe);
      scope.$watch(model, (value) => {
        if (value == true) {
          element[0].focus();
        }
      });
    }
  };
}
